import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';

import styles from './styles.module.scss';

type Props = {
  isOpen: boolean;
  memberName?: string;
  onCancel: () => void;
  onConfirm: () => void;
};

const ConfirmRemoveMemberModal: React.FC<Props> = ({ isOpen, memberName, onCancel, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className={styles.modal}
      overlayClassName={styles.overlay}
      ariaHideApp={false}
    >
      <button className={styles.closeBtn} onClick={onCancel} aria-label="Close" type="button">
        <AiOutlineClose />
      </button>

      <p className={`fs-unmask ${styles.message}`} role="alert">
        Are you sure you want to remove{memberName ? ` ${memberName}` : ' this member'} from your plan?
      </p>

      <button
        type="button"
        className={`fs-unmask ${styles.removeBtn}`}
        onClick={onConfirm}
        aria-label="Remove from plan"
      >
        Remove from plan
      </button>

      <button type="button" className={`fs-unmask ${styles.keepBtn}`} onClick={onCancel} aria-label="Keep member">
        Keep member
      </button>
    </Modal>
  );
};

export default ConfirmRemoveMemberModal;
